// extracted by mini-css-extract-plugin
export var bottomRightDock = "_52-0";